import React, { useEffect, useState } from 'react';
import { Container } from '@exxonmobil/react-unity';
import dayjs from 'dayjs';
import PageTitle from '../common/components/PageTitle';
import { useAxiosRequestWithParams, useGetClient } from '../common/utils/withTokenClient';
import ChartGroup from './components/ChartGroup';
import TrendsFieldSet, { Period } from './components/TrendsFieldSet';
import { INSTANT_FIRST_DAY_OF_THE_YEAR, INSTANT_FORMAT, INSTANT_TODAY } from '../common/date';

const Trends = () => {
  const [timePeriod, setTimePeriod] = useState(Period.YTD);
  const [startDateTime, setStartDateTime] = useState(INSTANT_FIRST_DAY_OF_THE_YEAR);
  const [endDateTime, setEndDateTime] = useState(INSTANT_TODAY);
  const [domainId, setDomainId] = useState('all');
  const [domainName, setDomainName] = useState('All Domain');

  const is30Days = timePeriod === Period.Last30Days;

  const { data: domains, isLoading: domainsIsLoading } = useGetClient('domains');
  const {
    data: overall,
    error: overallError,
    isLoading: overallIsLoading,
    token: overallToken,
    fetch: overallFetch
  } = useAxiosRequestWithParams();
  const {
    data: volume,
    error: volumeError,
    isLoading: volumeIsLoading,
    token: volumeToken,
    fetch: volumeFetch
  } = useAxiosRequestWithParams();
  const {
    data: cost,
    error: costError,
    isLoading: costIsLoading,
    token: costToken,
    fetch: costFetch
  } = useAxiosRequestWithParams();

  const overallFetchApi = () => {
    if (domainId === 'all') {
      overallFetch({
        api: `trends/overall?startTime=${startDateTime}&endTime=${endDateTime}`,
        payload: null,
        method: 'GET'
      });
    } else {
      overallFetch({
        api: `trends/overall/${domainId}?startTime=${startDateTime}&endTime=${endDateTime}`,
        payload: null,
        method: 'GET'
      });
    }
  };
  const volumeFetchApi = () => {
    if (domainId === 'all') {
      volumeFetch({
        api: `trends/volume?startTime=${startDateTime}&endTime=${endDateTime}`,
        payload: null,
        method: 'GET'
      });
    } else {
      volumeFetch({
        api: `trends/volume/${domainId}?startTime=${startDateTime}&endTime=${endDateTime}`,
        payload: null,
        method: 'GET'
      });
    }
  };
  const costFetchApi = () => {
    if (is30Days) {
      const startDateLastMonth = `${dayjs().subtract(1, 'month').startOf('month').format(INSTANT_FORMAT)}Z`;
      const endDateLastMonth = `${dayjs().subtract(1, 'month').endOf('month').startOf('day').format(INSTANT_FORMAT)}Z`;
      costFetch({
        api: `trends/cost?startTime=${startDateLastMonth}&endTime=${endDateLastMonth}`,
        payload: null,
        method: 'GET'
      });
    } else if (domainId === 'all') {
      costFetch({
        api: `trends/cost?startTime=${startDateTime}&endTime=${endDateTime}`,
        payload: null,
        method: 'GET'
      });
    }
  };

  useEffect(() => {
    overallFetchApi();
    volumeFetchApi();
    costFetchApi();
  }, [startDateTime, endDateTime, domainId, overallToken, volumeToken, costToken]);
  return (
    <>
      <PageTitle title="Trends" isLoading={false} />
      <Container>
        <TrendsFieldSet
          setTimePeriod={setTimePeriod}
          setStartDateTime={setStartDateTime}
          startDateTime={startDateTime}
          setEndDateTime={setEndDateTime}
          endDateTime={endDateTime}
          setDomainId={setDomainId}
          domainId={domainId}
          setDomainName={setDomainName}
          domains={domains || []}
          domainsIsLoading={domainsIsLoading}
        />
        <ChartGroup
          overall={
            overall || {
              dates: [],
              domains: [],
              endpoints: [],
              consumers: []
            }
          }
          overallIsLoading={overallIsLoading}
          overallError={overallError}
          overallOnRefresh={overallFetchApi}
          volume={
            volume || {
              dates: [],
              apiUsage: [],
              eventUsage: []
            }
          }
          volumeIsLoading={volumeIsLoading}
          volumeError={volumeError}
          volumeOnRefresh={volumeFetchApi}
          cost={cost || []}
          costIsLoading={costIsLoading}
          costError={costError}
          costOnRefresh={costFetchApi}
          domainName={domainName}
          is30Days={is30Days}
          timePeriod={timePeriod}
        />
      </Container>
    </>
  );
};

export default Trends;
